// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { v4 as uuidv4 } from 'uuid';
// import axios from 'axios';
// import Alert from '@mui/material/Alert';

// const ModuleFlaggedForm = () => {
//   const [modules, setModules] = useState([]);
//   const [palletForm, setPalletForm] = useState('');
//   const [excessModule, setExcessModule] = useState('');
//   const [quantities, setQuantities] = useState({ accepted: 0, rejected: 0, short: 0, different: 0, damage: 0, excess: 0, totalRejected: 0 });
//   const [loading, setLoading] = useState(false);
//   const [apiMessage, setApiMessage] = useState(null);
//   const navigate = useNavigate();
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   useEffect(() => {
//     const flaggedPalletData = JSON.parse(sessionStorage.getItem('flaggedPalletData') || '{}');
//     const palletNumber = flaggedPalletData?.palletNumber || null;
//     if (!palletNumber) {
//       setApiMessage('No pallet number found in sessionStorage');
//       return;
//     }
//     setPalletForm(palletNumber);
//     const fetchModuleSerials = async () => {
//       const projectId = localStorage.getItem('selectedProject');
//       const supplierName = sessionStorage.getItem('selectedSupplierTab');
//       if (!projectId || !supplierName) {
//         setApiMessage('Missing project ID or supplier name');
//         return;
//       }
//       setLoading(true);
//       try {
//         const { data: { message, status, data } } = await axios.post(`${baseURL}get_module_sno`, {
//           projectId,
//           supplierName,
//           palletNumber,
//         });
//         setApiMessage(message || (status === 'success' ? 'Modules retrieved successfully' : 'Unknown response'));
//         setModules(data.map(serial => ({ id: uuidv4(), srNo: serial, action: '', evidence: [], remarks: '', isExcess: false })));
//       } catch (err) {
//         setApiMessage(err.response?.data?.message || 'Failed to fetch module serial numbers');
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchModuleSerials();
//   }, []);

//   useEffect(() => {
//     const newQuantities = modules.reduce(
//       (acc, { action, isExcess }) => ({
//         ...acc,
//         accepted: action === 'Accept' ? acc.accepted + 1 : acc.accepted,
//         rejected: action === 'Reject' ? acc.rejected + 1 : acc.rejected,
//         short: action === 'Short' ? acc.short + 1 : acc.short,
//         different: action === 'Different' ? acc.different + 1 : acc.different,
//         damage: action === 'Damage' ? acc.damage + 1 : acc.damage,
//         excess: isExcess ? acc.excess + 1 : acc.excess,
//       }),
//       { accepted: 0, rejected: 0, short: 0, different: 0, damage: 0, excess: 0, totalRejected: 0 }
//     );
//     newQuantities.totalRejected = newQuantities.rejected + newQuantities.short + newQuantities.different + newQuantities.damage;
//     setQuantities(newQuantities);
//   }, [modules]);

//   const handleActionChange = (id, action) => setModules(modules.map(m => m.id === id ? { ...m, action } : m));
//   const handleBulkAction = action => setModules(modules.map(m => ({ ...m, action })));
//   const handleFileUpload = (id, files) => {
//     const fileArray = Array.from(files).map(file => ({ name: file.name, file, id: uuidv4() }));
//     setModules(modules.map(m => m.id === id ? { ...m, evidence: [...m.evidence, ...fileArray] } : m));
//   };
//   const handleRemoveFile = (id, fileId) => setModules(modules.map(m => m.id === id ? { ...m, evidence: m.evidence.filter(f => f.id !== fileId) } : m));
//   const handleRemarksChange = (id, remarks) => setModules(modules.map(m => m.id === id ? { ...m, remarks } : m));
//   const addExcessModule = () => excessModule.trim() && (setModules([...modules, { id: uuidv4(), srNo: excessModule, action: '', evidence: [], remarks: '', isExcess: true }]), setExcessModule(''));
//   const discardExcessModule = id => setModules(modules.filter(m => m.id !== id));

//   const uploadFileInChunks = async (file, moduleSrNo, fileIndex, projectId, supplierName, palletNumber, orderNo, invoiceNo, vehicleNo, receivedOn, shippedOn) => {
//     const CHUNK_SIZE = 1 * 1024 * 1024; // 1MB
//     const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
//     const fileId = uuidv4();

//     for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
//       const start = chunkIndex * CHUNK_SIZE;
//       const end = Math.min(start + CHUNK_SIZE, file.size);
//       const chunk = file.slice(start, end);

//       const chunkFormData = new FormData();
//       chunkFormData.append('projectId', projectId);
//       chunkFormData.append('supplierName', supplierName);
//       chunkFormData.append('palletNumber', palletNumber);
//       chunkFormData.append('orderNumber', orderNo);
//       chunkFormData.append('invoiceNumber', invoiceNo);
//       chunkFormData.append('vehicleNumber', vehicleNo);
//       chunkFormData.append('receivedDateTime', receivedOn);
//       chunkFormData.append('dateOfShipping', shippedOn);
//       chunkFormData.append('moduleSrNo', moduleSrNo);
//       chunkFormData.append('fileIndex', fileIndex);
//       chunkFormData.append('fileId', fileId);
//       chunkFormData.append('fileName', file.name);
//       chunkFormData.append('chunkIndex', chunkIndex);
//       chunkFormData.append('totalChunks', totalChunks);
//       chunkFormData.append('chunk', chunk);
//       chunkFormData.append('isChunked', 'true');

//       try {
//         const response = await axios.post(`${baseURL}create_pallet_inspection`, chunkFormData, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         });
//         if (response.status !== 200 || response.data.status !== 'success') {
//           throw new Error(`Chunk ${chunkIndex} upload failed for file ${file.name}: ${response.data.message || 'Unknown error'}`);
//         }
//       } catch (error) {
//         throw new Error(`Chunk ${chunkIndex} upload failed for file ${file.name}: ${error.message}`);
//       }
//     }
//   };

//   const handleSubmit = async () => {
//     const flaggedPalletData = JSON.parse(sessionStorage.getItem('flaggedPalletData') || '{}');
//     const projectId = localStorage.getItem('selectedProject');
//     const supplierName = sessionStorage.getItem('selectedSupplierTab');
//     const { palletNumber, orderNo, invoiceNo, vehicleNo, receivedOn, shippedOn } = flaggedPalletData;

//     if (!projectId || !supplierName || !palletNumber || !orderNo || !invoiceNo || !vehicleNo || !receivedOn || !shippedOn) {
//       setApiMessage('Missing required fields in sessionStorage or localStorage');
//       return;
//     }

//     setLoading(true);
//     try {
//       // Upload all files in chunks
//       const uploadPromises = [];
//       for (let index = 0; index < modules.length; index++) {
//         const module = modules[index];
//         for (let fileIndex = 0; fileIndex < module.evidence.length; fileIndex++) {
//           const fileObj = module.evidence[fileIndex];
//           uploadPromises.push(
//             uploadFileInChunks(
//               fileObj.file,
//               module.srNo,
//               fileIndex,
//               projectId,
//               supplierName,
//               palletNumber,
//               orderNo,
//               invoiceNo,
//               vehicleNo,
//               receivedOn,
//               shippedOn
//             )
//           );
//         }
//       }
//       await Promise.all(uploadPromises);

//       // Send final metadata request
//       const formData = new FormData();
//       formData.append('projectId', projectId);
//       formData.append('supplierName', supplierName);
//       formData.append('palletNumber', palletNumber);
//       formData.append('orderNumber', orderNo);
//       formData.append('invoiceNumber', invoiceNo);
//       formData.append('vehicleNumber', vehicleNo);
//       formData.append('receivedDateTime', receivedOn);
//       formData.append('dateOfShipping', shippedOn);
//       formData.append('quantities[accepted]', quantities.accepted);
//       formData.append('quantities[rejected]', quantities.rejected);
//       formData.append('quantities[short]', quantities.short);
//       formData.append('quantities[different]', quantities.different);
//       formData.append('quantities[damage]', quantities.damage);
//       formData.append('quantities[excess]', quantities.excess);
//       formData.append('quantities[totalRejected]', quantities.totalRejected);
//       modules.forEach((module, index) => {
//         formData.append(`modules[${index}][srNo]`, module.srNo);
//         formData.append(`modules[${index}][action]`, module.action || '');
//         formData.append(`modules[${index}][remarks]`, module.remarks || '');
//       });
//       formData.append('isChunked', 'false');

//       const { data: { message, status } } = await axios.post(
//         `${baseURL}create_pallet_inspection`,
//         formData,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         }
//       );
//       if (status === 'success') {
//         setApiMessage('Pallet inspection and evidence submitted successfully');
//         navigate('/receiving-modules');
//       } else {
//         setApiMessage(message || 'Failed to submit metadata');
//       }
//     } catch (err) {
//       setApiMessage(err.message || 'Failed to submit pallet inspection');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBackToForms = () => {
//     navigate('/receiving-modules');
//     sessionStorage.removeItem('flaggedPalletData');
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">
//       <button
//         onClick={handleBackToForms}
//         className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
//       >
//         ← Back to Vehicles Awaiting List
//       </button>
//       <div className="w-full mx-auto bg-white rounded-xl shadow-2xl p-8">
//         <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Module Wise Scanning</h1>
//         <div className="mb-6">
//           <label className="block text-lg font-medium text-gray-700 mb-2">Pallet Form:</label>
//           <div className="bg-gray-50 p-3 rounded-lg text-gray-800 font-semibold">{palletForm || 'No pallet selected'}</div>
//         </div>
//         {apiMessage && <Alert severity={apiMessage.includes('Failed') ? 'error' : 'info'} sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}>{apiMessage}</Alert>}
//         {loading ? (
//           <div className="text-center mb-4">Loading...</div>
//         ) : (
//           <>
//             <div className="overflow-x-auto rounded-lg border border-gray-200">
//               <table className="w-full table-auto border-collapse">
//                 <thead>
//                   <tr className="bg-gray-600 text-white">
//                     <th className="p-3 text-left rounded-tl-lg">Module Sr No</th>
//                     <th className="p-3 text-left">
//                       Action
//                       <div className="inline-flex ml-2 space-x-2">
//                         <button onClick={() => handleBulkAction('Accept')} className="text-sm bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded">Accept All</button>
//                         <button onClick={() => handleBulkAction('Reject')} className="text-sm bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded">Reject All</button>
//                         <button onClick={() => handleBulkAction('Short')} className="text-sm bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded">Short All</button>
//                       </div>
//                     </th>
//                     <th className="p-3 text-left">Upload Evidence</th>
//                     <th className="p-3 text-left">Remarks</th>
//                     <th className="p-3 text-left rounded-tr-lg"></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {modules.length ? modules.map(({ id, srNo, action, evidence, remarks, isExcess }) => (
//                     <tr key={id} className="border-b hover:bg-gray-50 last:border-b-0">
//                       <td className="p-3">{srNo}</td>
//                       <td className="p-3">
//                         <select value={action} onChange={e => handleActionChange(id, e.target.value)} className="w-full p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500">
//                           <option value="">Select Action</option>
//                           {['Accept', 'Reject', 'Short', 'Different', 'Damage'].map(opt => <option key={opt} value={opt}>{opt}</option>)}
//                         </select>
//                       </td>
//                       <td className="p-3">
//                         <input
//                           type="file"
//                           multiple
//                           onChange={e => handleFileUpload(id, e.target.files)}
//                           className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-gray-50 file:text-gray-700 hover:file:bg-gray-100"
//                         />
//                         {evidence.map(file => (
//                           <div key={file.id} className="flex items-center mt-1 text-sm text-gray-600">
//                             <span className="truncate flex-1">{file.name}</span>
//                             <button onClick={() => handleRemoveFile(id, file.id)} className="ml-2 text-red-400 hover:text-red-600 font-semibold">x</button>
//                           </div>
//                         ))}
//                       </td>
//                       <td className="p-3">
//                         <input
//                           type="text"
//                           value={remarks}
//                           onChange={e => handleRemarksChange(id, e.target.value)}
//                           className="w-full p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500"
//                           placeholder="Enter remarks"
//                         />
//                       </td>
//                       <td className="p-3">{isExcess && <button onClick={() => discardExcessModule(id)} className="text-red-500 hover:text-red-700 font-semibold">Discard</button>}</td>
//                     </tr>
//                   )) : (
//                     <tr><td colSpan="5" className="p-3 text-center text-gray-500">No modules found</td></tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             <div className="mt-6 flex items-center space-x-4">
//               <input
//                 type="text"
//                 value={excessModule}
//                 onChange={e => setExcessModule(e.target.value)}
//                 placeholder="Enter excess module Sr No"
//                 className="flex-1 p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500"
//               />
//               <button onClick={addExcessModule} className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700">Add Module</button>
//             </div>
//             <div className="mt-8 grid grid-cols-2 sm:grid-cols-6 gap-4">
//               {[
//                 { label: 'Accepted', value: quantities.accepted, color: 'green' },
//                 { label: 'Rejected', value: quantities.rejected, color: 'red' },
//                 { label: 'Short', value: quantities.short, color: 'red' },
//                 { label: 'Different Make', value: quantities.different, color: 'red' },
//                 { label: 'Damage', value: quantities.damage, color: 'red' },
//                 { label: 'Excess', value: quantities.excess, color: 'blue' },
//               ].map(({ label, value, color }) => (
//                 <div key={label} className={`bg-${color}-100 p-4 rounded-lg text-center`}>
//                   <div className={`text-lg font-semibold text-${color}-800`}>{label}</div>
//                   <div className="text-2xl font-bold">{value}</div>
//                 </div>
//               ))}
//             </div>
//             <div className="mt-4 text-center text-lg font-semibold text-gray-800">
//               Total Rejected: {quantities.totalRejected}
//             </div>
//             <div className="mt-8 text-center">
//               <button onClick={handleSubmit} className="bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 text-lg font-semibold">Submit</button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ModuleFlaggedForm;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import Alert from '@mui/material/Alert';
import apiClient from '../../../pages/keycloak/axiosInstance';

const ModuleFlaggedForm = () => {
  const [modules, setModules] = useState([]);
  const [palletForm, setPalletForm] = useState('');
  const [excessModule, setExcessModule] = useState('');
  const [quantities, setQuantities] = useState({ accepted: 0, rejected: 0, short: 0, different: 0, damage: 0, excess: 0, totalRejected: 0 });
  const [loading, setLoading] = useState(false);
  const [apiMessage, setApiMessage] = useState(null);
  const [hasEditPermission, setHasEditPermission] = useState(false); // ← added

  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Check Receiving_Modules_Edit permission
  useEffect(() => {
    const userRoles = sessionStorage.getItem('userRoles');
    if (userRoles) {
      try {
        const roles = JSON.parse(userRoles);
        setHasEditPermission(Array.isArray(roles) && roles.includes('Receiving_Modules_Edit'));
      } catch (e) {
        console.error('Error parsing userRoles:', e);
        setHasEditPermission(false);
      }
    }
  }, []);

  useEffect(() => {
    const flaggedPalletData = JSON.parse(sessionStorage.getItem('flaggedPalletData') || '{}');
    const palletNumber = flaggedPalletData?.palletNumber || null;
    if (!palletNumber) {
      setApiMessage('No pallet number found in sessionStorage');
      return;
    }
    setPalletForm(palletNumber);
    const fetchModuleSerials = async () => {
      const projectId = localStorage.getItem('selectedProject');
      const supplierName = sessionStorage.getItem('selectedSupplierTab');
      if (!projectId || !supplierName) {
        setApiMessage('Missing project ID or supplier name');
        return;
      }
      setLoading(true);
      try {
        const { data: { message, status, data } } = await apiClient.post(`get_module_sno`, {
          projectId,
          supplierName,
          palletNumber,
        });
        setApiMessage(message || (status === 'success' ? 'Modules retrieved successfully' : 'Unknown response'));
        setModules(data.map(serial => ({ id: uuidv4(), srNo: serial, action: '', evidence: [], remarks: '', isExcess: false })));
      } catch (err) {
        setApiMessage(err.response?.data?.message || 'Failed to fetch module serial numbers');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchModuleSerials();
  }, []);

  useEffect(() => {
    const newQuantities = modules.reduce(
      (acc, { action, isExcess }) => ({
        ...acc,
        accepted: action === 'Accept' ? acc.accepted + 1 : acc.accepted,
        rejected: action === 'Reject' ? acc.rejected + 1 : acc.rejected,
        short: action === 'Short' ? acc.short + 1 : acc.short,
        different: action === 'Different' ? acc.different + 1 : acc.different,
        damage: action === 'Damage' ? acc.damage + 1 : acc.damage,
        excess: isExcess ? acc.excess + 1 : acc.excess,
      }),
      { accepted: 0, rejected: 0, short: 0, different: 0, damage: 0, excess: 0, totalRejected: 0 }
    );
    newQuantities.totalRejected = newQuantities.rejected + newQuantities.short + newQuantities.different + newQuantities.damage;
    setQuantities(newQuantities);
  }, [modules]);

  const handleActionChange = (id, action) => setModules(modules.map(m => m.id === id ? { ...m, action } : m));
  const handleBulkAction = action => setModules(modules.map(m => ({ ...m, action })));
  const handleFileUpload = (id, files) => {
    const fileArray = Array.from(files).map(file => ({ name: file.name, file, id: uuidv4() }));
    setModules(modules.map(m => m.id === id ? { ...m, evidence: [...m.evidence, ...fileArray] } : m));
  };
  const handleRemoveFile = (id, fileId) => setModules(modules.map(m => m.id === id ? { ...m, evidence: m.evidence.filter(f => f.id !== fileId) } : m));
  const handleRemarksChange = (id, remarks) => setModules(modules.map(m => m.id === id ? { ...m, remarks } : m));
  const addExcessModule = () => excessModule.trim() && (setModules([...modules, { id: uuidv4(), srNo: excessModule, action: '', evidence: [], remarks: '', isExcess: true }]), setExcessModule(''));
  const discardExcessModule = id => setModules(modules.filter(m => m.id !== id));

  const uploadFileInChunks = async (file, moduleSrNo, fileIndex, projectId, supplierName, palletNumber, orderNo, invoiceNo, vehicleNo, receivedOn, shippedOn) => {
    const CHUNK_SIZE = 1 * 1024 * 1024; // 1MB
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const fileId = uuidv4();

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);

      const chunkFormData = new FormData();
      chunkFormData.append('projectId', projectId);
      chunkFormData.append('supplierName', supplierName);
      chunkFormData.append('palletNumber', palletNumber);
      chunkFormData.append('orderNumber', orderNo);
      chunkFormData.append('invoiceNumber', invoiceNo);
      chunkFormData.append('vehicleNumber', vehicleNo);
      chunkFormData.append('receivedDateTime', receivedOn);
      chunkFormData.append('dateOfShipping', shippedOn);
      chunkFormData.append('moduleSrNo', moduleSrNo);
      chunkFormData.append('fileIndex', fileIndex);
      chunkFormData.append('fileId', fileId);
      chunkFormData.append('fileName', file.name);
      chunkFormData.append('chunkIndex', chunkIndex);
      chunkFormData.append('totalChunks', totalChunks);
      chunkFormData.append('chunk', chunk);
      chunkFormData.append('isChunked', 'true');

      try {
        const response = await apiClient.post(`create_pallet_inspection`, chunkFormData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.status !== 200 || response.data.status !== 'success') {
          throw new Error(`Chunk ${chunkIndex} upload failed for file ${file.name}: ${response.data.message || 'Unknown error'}`);
        }
      } catch (error) {
        throw new Error(`Chunk ${chunkIndex} upload failed for file ${file.name}: ${error.message}`);
      }
    }
  };

  const handleSubmit = async () => {
    const flaggedPalletData = JSON.parse(sessionStorage.getItem('flaggedPalletData') || '{}');
    const projectId = localStorage.getItem('selectedProject');
    const supplierName = sessionStorage.getItem('selectedSupplierTab');
    const { palletNumber, orderNo, invoiceNo, vehicleNo, receivedOn, shippedOn } = flaggedPalletData;

    if (!projectId || !supplierName || !palletNumber || !orderNo || !invoiceNo || !vehicleNo || !receivedOn || !shippedOn) {
      setApiMessage('Missing required fields in sessionStorage or localStorage');
      return;
    }

    setLoading(true);
    try {
      // Upload all files in chunks
      const uploadPromises = [];
      for (let index = 0; index < modules.length; index++) {
        const module = modules[index];
        for (let fileIndex = 0; fileIndex < module.evidence.length; fileIndex++) {
          const fileObj = module.evidence[fileIndex];
          uploadPromises.push(
            uploadFileInChunks(
              fileObj.file,
              module.srNo,
              fileIndex,
              projectId,
              supplierName,
              palletNumber,
              orderNo,
              invoiceNo,
              vehicleNo,
              receivedOn,
              shippedOn
            )
          );
        }
      }
      await Promise.all(uploadPromises);

      // Send final metadata request
      const formData = new FormData();
      formData.append('projectId', projectId);
      formData.append('supplierName', supplierName);
      formData.append('palletNumber', palletNumber);
      formData.append('orderNumber', orderNo);
      formData.append('invoiceNumber', invoiceNo);
      formData.append('vehicleNumber', vehicleNo);
      formData.append('receivedDateTime', receivedOn);
      formData.append('dateOfShipping', shippedOn);
      formData.append('quantities[accepted]', quantities.accepted);
      formData.append('quantities[rejected]', quantities.rejected);
      formData.append('quantities[short]', quantities.short);
      formData.append('quantities[different]', quantities.different);
      formData.append('quantities[damage]', quantities.damage);
      formData.append('quantities[excess]', quantities.excess);
      formData.append('quantities[totalRejected]', quantities.totalRejected);
      modules.forEach((module, index) => {
        formData.append(`modules[${index}][srNo]`, module.srNo);
        formData.append(`modules[${index}][action]`, module.action || '');
        formData.append(`modules[${index}][remarks]`, module.remarks || '');
      });
      formData.append('isChunked', 'false');

      const { data: { message, status } } = await apiClient.post(
        `create_pallet_inspection`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      if (status === 'success') {
        setApiMessage('Pallet inspection and evidence submitted successfully');
        navigate('/receiving-modules');
      } else {
        setApiMessage(message || 'Failed to submit metadata');
      }
    } catch (err) {
      setApiMessage(err.message || 'Failed to submit pallet inspection');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleBackToForms = () => {
    navigate('/receiving-modules');
    sessionStorage.removeItem('flaggedPalletData');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <button
        onClick={handleBackToForms}
        className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
      >
        ← Back to Vehicles Awaiting List
      </button>
      <div className="w-full mx-auto bg-white rounded-xl shadow-2xl p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Module Wise Scanning</h1>
        <div className="mb-6">
          <label className="block text-lg font-medium text-gray-700 mb-2">Pallet Form:</label>
          <div className="bg-gray-50 p-3 rounded-lg text-gray-800 font-semibold">{palletForm || 'No pallet selected'}</div>
        </div>
        {apiMessage && <Alert severity={apiMessage.includes('Failed') ? 'error' : 'info'} sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}>{apiMessage}</Alert>}
        {loading ? (
          <div className="text-center mb-4">Loading...</div>
        ) : (
          <>
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="w-full table-auto border-collapse">
                <thead>
                  <tr className="bg-gray-600 text-white">
                    <th className="p-3 text-left rounded-tl-lg">Module Sr No</th>
                    <th className="p-3 text-left">
                      Action
                      <div className="inline-flex ml-2 space-x-2">
                        <button onClick={() => handleBulkAction('Accept')} className="text-sm bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded">Accept All</button>
                        <button onClick={() => handleBulkAction('Reject')} className="text-sm bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded">Reject All</button>
                        <button onClick={() => handleBulkAction('Short')} className="text-sm bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded">Short All</button>
                      </div>
                    </th>
                    <th className="p-3 text-left">Upload Evidence</th>
                    <th className="p-3 text-left">Remarks</th>
                    <th className="p-3 text-left rounded-tr-lg"></th>
                  </tr>
                </thead>
                <tbody>
                  {modules.length ? modules.map(({ id, srNo, action, evidence, remarks, isExcess }) => (
                    <tr key={id} className="border-b hover:bg-gray-50 last:border-b-0">
                      <td className="p-3">{srNo}</td>
                      <td className="p-3">
                        <select value={action} onChange={e => handleActionChange(id, e.target.value)} className="w-full p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500">
                          <option value="">Select Action</option>
                          {['Accept', 'Reject', 'Short', 'Different', 'Damage'].map(opt => <option key={opt} value={opt}>{opt}</option>)}
                        </select>
                      </td>
                      <td className="p-3">
                        <input
                          type="file"
                          multiple
                          onChange={e => handleFileUpload(id, e.target.files)}
                          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-gray-50 file:text-gray-700 hover:file:bg-gray-100"
                        />
                        {evidence.map(file => (
                          <div key={file.id} className="flex items-center mt-1 text-sm text-gray-600">
                            <span className="truncate flex-1">{file.name}</span>
                            <button onClick={() => handleRemoveFile(id, file.id)} className="ml-2 text-red-400 hover:text-red-600 font-semibold">x</button>
                          </div>
                        ))}
                      </td>
                      <td className="p-3">
                        <input
                          type="text"
                          value={remarks}
                          onChange={e => handleRemarksChange(id, e.target.value)}
                          className="w-full p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500"
                          placeholder="Enter remarks"
                        />
                      </td>
                      <td className="p-3">{isExcess && <button onClick={() => discardExcessModule(id)} className="text-red-500 hover:text-red-700 font-semibold">Discard</button>}</td>
                    </tr>
                  )) : (
                    <tr><td colSpan="5" className="p-3 text-center text-gray-500">No modules found</td></tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="mt-6 flex items-center space-x-4">
              <input
                type="text"
                value={excessModule}
                onChange={e => setExcessModule(e.target.value)}
                placeholder="Enter excess module Sr No"
                className="flex-1 p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500"
              />
              <button onClick={addExcessModule} className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700">Add Module</button>
            </div>
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-6 gap-4">
              {[
                { label: 'Accepted', value: quantities.accepted, color: 'green' },
                { label: 'Rejected', value: quantities.rejected, color: 'red' },
                { label: 'Short', value: quantities.short, color: 'red' },
                { label: 'Different Make', value: quantities.different, color: 'red' },
                { label: 'Damage', value: quantities.damage, color: 'red' },
                { label: 'Excess', value: quantities.excess, color: 'blue' },
              ].map(({ label, value, color }) => (
                <div key={label} className={`bg-${color}-100 p-4 rounded-lg text-center`}>
                  <div className={`text-lg font-semibold text-${color}-800`}>{label}</div>
                  <div className="text-2xl font-bold">{value}</div>
                </div>
              ))}
            </div>
            <div className="mt-4 text-center text-lg font-semibold text-gray-800">
              Total Rejected: {quantities.totalRejected}
            </div>
            <div className="mt-8 text-center">
              {hasEditPermission ? (
                <button onClick={handleSubmit} className="bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 text-lg font-semibold">
                  Submit
                </button>
              ) : (
                <p className="text-red-600 text-lg font-medium">
                  You do not have access to fill this form
                </p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ModuleFlaggedForm;


// // import React, { useState, useEffect } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { v4 as uuidv4 } from 'uuid';
// // import axios from 'axios';
// // import Alert from '@mui/material/Alert';

// // const ModuleFlaggedForm = () => {
// //   const [modules, setModules] = useState([]);
// //   const [palletForm, setPalletForm] = useState('');
// //   const [excessModule, setExcessModule] = useState('');
// //   const [quantities, setQuantities] = useState({ accepted: 0, rejected: 0, short: 0, different: 0, damage: 0, excess: 0, totalRejected: 0 });
// //   const [loading, setLoading] = useState(false);
// //   const [apiMessage, setApiMessage] = useState(null);
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     const flaggedPalletData = JSON.parse(sessionStorage.getItem('flaggedPalletData') || '{}');
// //     const palletNumber = flaggedPalletData?.palletNumber || null;
// //     if (!palletNumber) {
// //       setApiMessage('No pallet number found in sessionStorage');
// //       return;
// //     }
// //     setPalletForm(palletNumber);
// //     const fetchModuleSerials = async () => {
// //       const projectId = localStorage.getItem('selectedProject');
// //       const supplierName = sessionStorage.getItem('selectedSupplierTab');
// //       if (!projectId || !supplierName) {
// //         setApiMessage('Missing project ID or supplier name');
// //         return;
// //       }
// //       setLoading(true);
// //       try {
// //         const { data: { message, status, data } } = await axios.post('https://redoms-backend-dev.m-devsecops.com/get_module_sno', {
// //           projectId,
// //           supplierName,
// //           palletNumber,
// //         });
// //         setApiMessage(message || (status === 'success' ? 'Modules retrieved successfully' : 'Unknown response'));
// //         setModules(data.map(serial => ({ id: uuidv4(), srNo: serial, action: '', evidence: [], remarks: '', isExcess: false })));
// //       } catch (err) {
// //         setApiMessage(err.response?.data?.message || 'Failed to fetch module serial numbers');
// //         console.error(err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchModuleSerials();
// //   }, []);

// //   useEffect(() => {
// //     const newQuantities = modules.reduce(
// //       (acc, { action, isExcess }) => ({
// //         ...acc,
// //         accepted: action === 'Accept' ? acc.accepted + 1 : acc.accepted,
// //         rejected: action === 'Reject' ? acc.rejected + 1 : acc.rejected,
// //         short: action === 'Short' ? acc.short + 1 : acc.short,
// //         different: action === 'Different' ? acc.different + 1 : acc.different,
// //         damage: action === 'Damage' ? acc.damage + 1 : acc.damage,
// //         excess: isExcess ? acc.excess + 1 : acc.excess,
// //       }),
// //       { accepted: 0, rejected: 0, short: 0, different: 0, damage: 0, excess: 0, totalRejected: 0 }
// //     );
// //     newQuantities.totalRejected = newQuantities.rejected + newQuantities.short + newQuantities.different + newQuantities.damage;
// //     setQuantities(newQuantities);
// //   }, [modules]);

// //   const handleActionChange = (id, action) => setModules(modules.map(m => m.id === id ? { ...m, action } : m));
// //   const handleBulkAction = action => setModules(modules.map(m => ({ ...m, action })));
// //   const handleFileUpload = (id, files) => {
// //     const fileArray = Array.from(files).map(file => ({ name: file.name, file, id: uuidv4() }));
// //     setModules(modules.map(m => m.id === id ? { ...m, evidence: [...m.evidence, ...fileArray] } : m));
// //   };
// //   const handleRemoveFile = (id, fileId) => setModules(modules.map(m => m.id === id ? { ...m, evidence: m.evidence.filter(f => f.id !== fileId) } : m));
// //   const handleRemarksChange = (id, remarks) => setModules(modules.map(m => m.id === id ? { ...m, remarks } : m));
// //   const addExcessModule = () => excessModule.trim() && (setModules([...modules, { id: uuidv4(), srNo: excessModule, action: '', evidence: [], remarks: '', isExcess: true }]), setExcessModule(''));
// //   const discardExcessModule = id => setModules(modules.filter(m => m.id !== id));

// //   const uploadFileInChunks = async (file, moduleSrNo, fileIndex, inspectionId) => {
// //     const CHUNK_SIZE = 1 * 1024 * 1024; // 1MB
// //     const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
// //     const fileId = uuidv4();

// //     for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
// //       const start = chunkIndex * CHUNK_SIZE;
// //       const end = Math.min(start + CHUNK_SIZE, file.size);
// //       const chunk = file.slice(start, end);

// //       const chunkFormData = new FormData();
// //       chunkFormData.append('inspectionId', inspectionId);
// //       chunkFormData.append('moduleSrNo', moduleSrNo);
// //       chunkFormData.append('fileIndex', fileIndex);
// //       chunkFormData.append('fileId', fileId);
// //       chunkFormData.append('fileName', file.name);
// //       chunkFormData.append('chunkIndex', chunkIndex);
// //       chunkFormData.append('totalChunks', totalChunks);
// //       chunkFormData.append('chunk', chunk);
// //       chunkFormData.append('isChunked', 'true');

// //       await axios.post('https://redoms-backend-dev.m-devsecops.com/create_pallet_inspection', chunkFormData, {
// //         headers: { 'Content-Type': 'multipart/form-data' },
// //       });
// //     }
// //   };

// //   const handleSubmit = async () => {
// //     const flaggedPalletData = JSON.parse(sessionStorage.getItem('flaggedPalletData') || '{}');
// //     const projectId = localStorage.getItem('selectedProject');
// //     const supplierName = sessionStorage.getItem('selectedSupplierTab');
// //     const { palletNumber, orderNo, invoiceNo, vehicleNo, receivedOn, shippedOn } = flaggedPalletData;

// //     if (!projectId || !supplierName || !palletNumber || !orderNo || !invoiceNo || !vehicleNo || !receivedOn || !shippedOn) {
// //       setApiMessage('Missing required fields in sessionStorage or localStorage');
// //       return;
// //     }

// //     const formData = new FormData();
// //     formData.append('projectId', projectId);
// //     formData.append('supplierName', supplierName);
// //     formData.append('palletNumber', palletNumber);
// //     formData.append('orderNumber', orderNo);
// //     formData.append('invoiceNumber', invoiceNo);
// //     formData.append('vehicleNumber', vehicleNo);
// //     formData.append('receivedDateTime', receivedOn);
// //     formData.append('dateOfShipping', shippedOn);
// //     formData.append('quantities[accepted]', quantities.accepted);
// //     formData.append('quantities[rejected]', quantities.rejected);
// //     formData.append('quantities[short]', quantities.short);
// //     formData.append('quantities[different]', quantities.different);
// //     formData.append('quantities[damage]', quantities.damage);
// //     formData.append('quantities[excess]', quantities.excess);
// //     formData.append('quantities[totalRejected]', quantities.totalRejected);
// //     modules.forEach((module, index) => {
// //       formData.append(`modules[${index}][srNo]`, module.srNo);
// //       formData.append(`modules[${index}][action]`, module.action || '');
// //       formData.append(`modules[${index}][remarks]`, module.remarks || '');
// //     });
// //     formData.append('isChunked', 'false');

// //     setLoading(true);
// //     try {
// //       const { data: { message, status, inspectionId } } = await axios.post(
// //         'https://redoms-backend-dev.m-devsecops.com/create_pallet_inspection',
// //         formData,
// //         {
// //           headers: { 'Content-Type': 'multipart/form-data' },
// //         }
// //       );
// //       if (status === 'success' && inspectionId) {
// //         for (let index = 0; index < modules.length; index++) {
// //           const module = modules[index];
// //           for (let fileIndex = 0; fileIndex < module.evidence.length; fileIndex++) {
// //             const fileObj = module.evidence[fileIndex];
// //             await uploadFileInChunks(fileObj.file, module.srNo, fileIndex, inspectionId);
// //           }
// //         }
// //         setApiMessage('Pallet inspection and evidence submitted successfully');
// //         navigate('/receiving-modules');
// //       } else {
// //         setApiMessage(message || 'Unknown response');
// //       }
// //     } catch (err) {
// //       setApiMessage(err.response?.data?.message || 'Failed to submit pallet inspection');
// //       console.error(err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleBackToForms = () => {
// //     navigate('/receiving-modules');
// //     sessionStorage.removeItem('flaggedPalletData');
// //   };

// //   return (
// //     <div className="min-h-screen bg-gray-100 p-6">
// //       <button
// //         onClick={handleBackToForms}
// //         className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
// //       >
// //         ← Back to Vehicles Awaiting List
// //       </button>
// //       <div className="max-w-7xl mx-auto bg-white rounded-xl shadow-2xl p-8">
// //         <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">Module Wise Scanning</h1>
// //         <div className="mb-6">
// //           <label className="block text-lg font-medium text-gray-700 mb-2">Pallet Form:</label>
// //           <div className="bg-gray-50 p-3 rounded-lg text-gray-800 font-semibold">{palletForm || 'No pallet selected'}</div>
// //         </div>
// //         {apiMessage && <Alert severity={apiMessage.includes('Failed') ? 'error' : 'info'} sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}>{apiMessage}</Alert>}
// //         {loading ? (
// //           <div className="text-center mb-4">Loading...</div>
// //         ) : (
// //           <>
// //             <div className="overflow-x-auto rounded-lg border border-gray-200">
// //               <table className="w-full table-auto border-collapse">
// //                 <thead>
// //                   <tr className="bg-gray-600 text-white">
// //                     <th className="p-3 text-left rounded-tl-lg">Module Sr No</th>
// //                     <th className="p-3 text-left">
// //                       Action
// //                       <div className="inline-flex ml-2 space-x-2">
// //                         <button onClick={() => handleBulkAction('Accept')} className="text-sm bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded">Accept All</button>
// //                         <button onClick={() => handleBulkAction('Reject')} className="text-sm bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded">Reject All</button>
// //                       </div>
// //                     </th>
// //                     <th className="p-3 text-left">Upload Evidence</th>
// //                     <th className="p-3 text-left">Remarks</th>
// //                     <th className="p-3 text-left rounded-tr-lg"></th>
// //                   </tr>
// //                 </thead>
// //                 <tbody>
// //                   {modules.length ? modules.map(({ id, srNo, action, evidence, remarks, isExcess }) => (
// //                     <tr key={id} className="border-b hover:bg-gray-50 last:border-b-0">
// //                       <td className="p-3">{srNo}</td>
// //                       <td className="p-3">
// //                         <select value={action} onChange={e => handleActionChange(id, e.target.value)} className="w-full p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500">
// //                           <option value="">Select Action</option>
// //                           {['Accept', 'Reject', 'Short', 'Different', 'Damage'].map(opt => <option key={opt} value={opt}>{opt}</option>)}
// //                         </select>
// //                       </td>
// //                       <td className="p-3">
// //                         <input
// //                           type="file"
// //                           multiple
// //                           onChange={e => handleFileUpload(id, e.target.files)}
// //                           className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-gray-50 file:text-gray-700 hover:file:bg-gray-100"
// //                         />
// //                         {evidence.map(file => (
// //                           <div key={file.id} className="flex items-center mt-1 text-sm text-gray-600">
// //                             <span className="truncate flex-1">{file.name}</span>
// //                             <button onClick={() => handleRemoveFile(id, file.id)} className="ml-2 text-red-400 hover:text-red-600 font-semibold">x</button>
// //                           </div>
// //                         ))}
// //                       </td>
// //                       <td className="p-3">
// //                         <input
// //                           type="text"
// //                           value={remarks}
// //                           onChange={e => handleRemarksChange(id, e.target.value)}
// //                           className="w-full p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500"
// //                           placeholder="Enter remarks"
// //                         />
// //                       </td>
// //                       <td className="p-3">{isExcess && <button onClick={() => discardExcessModule(id)} className="text-red-500 hover:text-red-700 font-semibold">Discard</button>}</td>
// //                     </tr>
// //                   )) : (
// //                     <tr><td colSpan="5" className="p-3 text-center text-gray-500">No modules found</td></tr>
// //                   )}
// //                 </tbody>
// //               </table>
// //             </div>
// //             <div className="mt-6 flex items-center space-x-4">
// //               <input
// //                 type="text"
// //                 value={excessModule}
// //                 onChange={e => setExcessModule(e.target.value)}
// //                 placeholder="Enter excess module Sr No"
// //                 className="flex-1 p-2 border rounded-lg focus:ring-gray-500 focus:border-gray-500"
// //               />
// //               <button onClick={addExcessModule} className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700">Add Module</button>
// //             </div>
// //             <div className="mt-8 grid grid-cols-2 sm:grid-cols-6 gap-4">
// //               {[
// //                 { label: 'Accepted', value: quantities.accepted, color: 'green' },
// //                 { label: 'Rejected', value: quantities.rejected, color: 'red' },
// //                 { label: 'Short', value: quantities.short, color: 'yellow' },
// //                 { label: 'Different Make', value: quantities.different, color: 'blue' },
// //                 { label: 'Damage', value: quantities.damage, color: 'orange' },
// //                 { label: 'Excess', value: quantities.excess, color: 'purple' },
// //               ].map(({ label, value, color }) => (
// //                 <div key={label} className={`bg-${color}-100 p-4 rounded-lg text-center`}>
// //                   <div className={`text-lg font-semibold text-${color}-800`}>{label}</div>
// //                   <div className="text-2xl font-bold">{value}</div>
// //                 </div>
// //               ))}
// //             </div>
// //             <div className="mt-4 text-center text-lg font-semibold text-gray-800">
// //               Total Rejected: {quantities.totalRejected}
// //             </div>
// //             <div className="mt-8 text-center">
// //               <button onClick={handleSubmit} className="bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 text-lg font-semibold">Submit</button>
// //             </div>
// //           </>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default ModuleFlaggedForm;